import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'

import Layout from 'components/PageLayout'
import SEO from 'components/SEO'
import Banner from 'components/Banner'
import Footer from 'components/Footer'

import Completed from './completed'
import Pictures from './pictures'
// import Potential from './potential'

export const EaglePageTemplate = ({
  seo,
  header,
  completed,
  pictures,
  potential
}) => (
  <Fragment>
    <Banner
      sizes={header.image.childImageSharp.fluid}
      title={header.title}
      paragraph={header.paragraph}
    />
    <Completed heading={completed.heading} projects={completed.projects} />
    <Pictures heading={pictures.heading} images={pictures.images} />
    {/* <Potential
      heading={potential.heading}
      subheading={potential.subheading}
      projects={potential.projects}
    /> */}
    <Footer />
  </Fragment>
)

export default ({ data }) => {
  const { frontmatter } = data.markdownRemark
  const { title, description } = frontmatter.seo
  return (
    <Layout>
      <SEO title={title} description={description} />
      <Helmet title={title} />
      <EaglePageTemplate
        header={frontmatter.header}
        completed={frontmatter.completed}
        pictures={frontmatter.pictures}
        potential={frontmatter.potential}
      />
    </Layout>
  )
}

export const query = graphql`
  query EaglePageQuery($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        seo {
          title
          description
        }
        header {
          title
          paragraph
          image {
            childImageSharp {
              fluid(maxWidth: 2000) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        completed {
          heading
          projects {
            date
            name
            project
          }
        }
        pictures {
          heading
          images {
            image {
              childImageSharp {
                fluid(maxWidth: 2000) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
        potential {
          heading
          subheading
          projects {
            project
          }
        }
      }
    }
  }
`
